/** @format */

import { message } from "antd";
import React from "react";

/** Risposta di un salvataggio dei turni: ci interessa solo il campo "avvisi". */
interface TRispostaConAvvisi {
  avvisi?: TAvvisoContratto[];
}

/**
 * Fase 3: turni programmati oltre il contratto.
 * Le risposte di salvataggio dei turni (nuovo, modifica, cambio turno, ripeti, griglia) hanno il
 * campo aggiuntivo "avvisi": il turno è già salvato, qui si mostra solo un messaggio giallo.
 * Si usa message (non notification) perché le notifiche dei salvataggi chiudono le precedenti.
 */
export interface TAvvisoContratto {
  user_id?: number;
  codice: string;
  livello: string;
  dal: string;
  al: string;
  messaggio: string;
}

const MASSIMO_RIGHE = 5;

export const mostraAvvisiContratto = (avvisi: TAvvisoContratto[] | undefined): void => {
  if (!Array.isArray(avvisi) || avvisi.length === 0) return;

  const righe = avvisi.slice(0, MASSIMO_RIGHE).map(a => a.messaggio);
  const altri = avvisi.length - righe.length;

  message.warning({
    key: "avvisi-contratto",
    duration: 8,
    content: (
      <span style={{ textAlign: "left", display: "inline-block" }}>
        <strong>Turno salvato, ma oltre il contratto:</strong>
        {righe.map((riga, i) => (
          <div key={i}>{riga}</div>
        ))}
        {altri > 0 && <div>…e altri {altri} avvisi (vedi il calendario turni)</div>}
      </span>
    ),
  });
};

/** Risposta di un salvataggio dei turni con avvisi di contratto da mostrare. */
export const haAvvisiContratto = (
  method?: string,
  url?: string,
  data?: TRispostaConAvvisi | null
): boolean => {
  if (!url || !method) return false;

  const avvisi = data?.avvisi;

  return (
    ["post", "put"].includes(method.toLowerCase()) &&
    url.indexOf("/shift_plannings") !== -1 &&
    url.indexOf("/details") === -1 &&
    Array.isArray(avvisi) &&
    avvisi.length > 0
  );
};
